<template>
	<LayoutOffcanvasStandard ref="offcanvas" title="Invitar usuarios a la empresa" id="company-admin-user-invitation" @hidden="reset">
		<template #body>
			<template v-if="url">
				<p class="text-md text-break lh-xs">Invitación generada exitosamente, puedes copiar el link, o compartirlo.</p>
				<CommonFormInputCustomCopy v-model="url" title="Link de la invitación" placeholder="Sin dirección válida" :share="{ title: 'Invitación', text: `Te invito a unirte a ${company.name}` }" />
			</template>
			<template v-else>
				<p class="text-md text-break lh-xs">Se generará un enlace que podrás compartir con quien desees. Por seguridad, cada invitación será de un sólo uso y tendrá una validez de 24hs, si deseas invitar a muchas personas debes enviar una invitación a cada una.</p>
				<CommonFormInputCheckbox v-model="form.roles" title="Seleccionar roles" :options="rolesOptions" />
			</template>
		</template>
		<template #footer>
			<button type="button" class="btn rounded-pill w-100 btn-danger" :disabled="submitting" @click="reset" v-if="url">Crear nueva</button>
			<button type="button" class="btn rounded-pill w-100 btn-primary" :disabled="submitting" @click="invite" v-else>Invitar</button>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref, reactive, computed, inject } from 'vue';
	import store from '@/store';
	import router from '@/router';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CompanyAdminUserRepository from '@/repositories/modules/Company/Admin/User';

	export default {
		setup() {
			const { submitting, catchError } = composableForm();
			const $env = inject('$env');
			const offcanvas = ref(null);
			const company = computed(() => store.getters['company/info']);
			const rolesOptions = computed(() => _.mapValues($env.MODEL.User.roles, (role) => role.title));
			const url = ref(null);

			const form = reactive({
				roles: []
			});

			const reset = async () => {
				form.roles = [];
				url.value = null;
			}

			const invite = async () => {
				if(submitting.value) return;
				submitting.value = true;

				await CompanyAdminUserRepository.invite(form).then((response) => {
					url.value = `${window.location.origin}${router.resolve({ name: 'invitation.index', params: { uuid: response.data.uuid }}).href}`;
				}).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			const show = () => {
				offcanvas.value.offcanvas.show();
			}

			return { offcanvas, company, submitting, rolesOptions, url, form, reset, invite, show };
		}
	}
</script>